export default (settings: any) => settings['emptyFields'] * (1 / 60) * 10
